module.exports = __webpack_public_path__ + "static/media/Brick Costume Guy.1bd3df34.jpg";